import React, { useState,useEffect } from "react";
import { Link } from "react-router-dom";
import { mockRecipes, categories } from '../data/mockData';
import { motion } from "framer-motion";
import chefhat from "../assets/chef-cap.png";
import {
  ArrowRight,
  Clock,
  Users,
  Star,
  Sparkles,
  TrendingUp,
  Award,
} from "lucide-react";
import AiIcon from "../components/AiIcon";
import styles from "./HomePage.module.css";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import Chatbot from "../components/Chatbot";
import axios from "axios";
import { getCategoriesApi } from "../http/api";
import { useSelector } from "react-redux";
import { useTranslate } from "../components/UseTranslate";

export default function HomePage() {
  const featuredRecipes = mockRecipes.slice(0, 6);

  const {language} = useSelector((state) => state.language);


  const [categories,setCategories] = useState([]);
  const {t} = useTranslate();


  const fetchCategories=async()=> {
    try{
      const response = await axios.get(getCategoriesApi(language));
      console.log(response.data,"categories");
      setCategories(response?.data?.categories);
    }
    catch(err){
      console.log(err);
    }
  }

  useEffect(() => {
    fetchCategories();
  },[language])





  // hero images to cycle through
  const heroImages = [
    "https://i.pinimg.com/736x/4c/be/5b/4cbe5bb074f53458b9c144e4450a2784.jpg",
    "https://images.unsplash.com/photo-1504674900247-0877df9cc836",
    "https://img.freepik.com/premium-photo/delicious-fast-food-photography_955695-4741.jpg",
  ];

  const [currentHero, setCurrentHero] = React.useState(0);
 const [chatOpen, setChatOpen] = React.useState(false);
 const [pos, setPos] = React.useState({ x: 0, y: 0 });
     console.log(currentHero,"image")

  React.useEffect(() => {
    const interval = setInterval(() => {
      setCurrentHero((prev) => (prev + 1) % heroImages.length);
  
    }, 5000); 

    return () => clearInterval(interval);
  }, []);

  return (
    <div  className={styles.pageWrapper}
      onMouseMove={(e) => {
        setPos({ x: e.clientX, y: e.clientY });
      }}
      style={{
        "--x": `${pos.x}px`,
        "--y": `${pos.y}px`,
      }}>
        <Header />
        <div >
<AiIcon onClick={() => setChatOpen(true)} />
       <Chatbot 
  isOpen={chatOpen} 
  onClose={() => setChatOpen(false)} 
/>
        </div>
      {/* Hero Section */}
      <section className={styles.hero}>
        <div className={styles.heroOverlay}></div>
        <motion.img
          key={currentHero}
          src={heroImages[currentHero]}
          alt="Cooking"
          className={styles.heroImage}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 3 }}
        />

        <div className={styles.heroContent}>
        
          <h1>{t('Discover Incredible Recipes')}</h1>
          <motion.img
  src={chefhat}
  alt="Chef Hat"
  className={styles.chefHat}
  initial={{
    scale: 4,
    y: -10,
    opacity: 1,
    rotate: 0
  }}
  animate={{
    scale: 1,
    y: 0,
    opacity: 1,
    rotate: [0, -20, 20, -15, 15, 0]
  }}
  transition={{
    duration: 5,
    ease: "easeInOut"
  }}
  whileHover={{
    rotate: [-10, 10, -10],
    y: -5
  }}
/>
          <p>
            {t('Share your culinary creations and explore recipes from chefs around the world')}
          </p>
          <div className={styles.heroButtons}>
            <Link to="/add-recipe" className={styles.primaryBtn}>
              {t('Share Recipe')} <ArrowRight size={18} />
            </Link>
            <a href="#categories" className={styles.secondaryBtn}>
              {t('Browse by Category')}
            </a>
          </div>
        </div>
      </section>

      {/* Categories Section */}
<section id="categories" className={styles.section}>
  <div className={styles.bgImage}></div>

  <h2>{t('Browse by Category')}</h2>
<div className={styles.grid}>
  {categories.map((category) => (
    <Link
      key={category.id}
      to={`/category/${category?.id}`}
      className={styles.categoryCard}
    >
      <div className={styles.cardInner}>
        
        {/* Front Side */}
        <div className={styles.cardFront}>
          <img src={category?.image_url} alt={category?.category_name} />
          <div className={styles.cardOverlay}>
            <h3>{category?.category_name}</h3>
            <p>{category?.recipe_count} {t('recipes')}</p>
          </div>
        </div>

        {/* Back Side (Video) */}
              <div className={styles.cardBack} style={{
    backgroundImage: `url(${category.image_url})`,
  }}>
  <div className={styles.backContent}>
    <span className={styles.categoryId}>
      Category #{category.id}
    </span>

    <h3>{category.category_name}</h3>

    <p>{category.description}</p>
  </div>
</div>

      </div>
    </Link>
  ))}
</div>
</section>
      {/* Featured Recipes */}
   <section className={styles.sectionWhite}>
  <div className={styles.marqueeWrapper}>
    <div className={styles.marquee}>
      {featuredRecipes.concat(featuredRecipes).map((recipe, i) => (
        <div key={i} className={styles.movingCard}>
          <img src={recipe.image} alt={recipe.title} className={styles.movingImage} />
          
        </div>
      ))}

      {/* Extra text scrolling separately */}
   
    </div>
      
    
    
  </div>
</section>

      {/* CTA Section */}
      {/* <section className={styles.cta}>
        <h2>Ready to Share Your Recipe?</h2>
        <p>Join our community of passionate home chefs</p>
        <Link to="/signup" className={styles.startBtn}>
          Get Started <ArrowRight size={18} />
        </Link>
      </section> */}
      <Footer />
    </div>
  );
}